import { useMutation, useQueryClient } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useRecogRecipientsDelete = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    params => {
      return recognitionServices.recogRecipientsDelete(params);
    },
    {
      ...options,
      onSuccess(data, variables) {
        queryClient.invalidateQueries({
          queryKey: 'recognition-recipients',
          refetchType: 'active'
        });

        if (variables?.code) {
          queryClient.invalidateQueries({
            queryKey: ['recognitionSpendingSummary', variables.code],
            refetchType: 'active'
          });
        }
      }
    }
  );
};
